import { YesNoEmpty } from '@interfaces/models';
import { Action, createReducer, on } from '@ngrx/store';

import * as trustActions from '../../actions/trust/trust.actions';

export interface TrustTaxInfoState {
  ein?: string;
  withholdingQuestion: YesNoEmpty;
  signature: string;
  date: string;
  ssn?: string;
  grantorName?: string;
  numberQuestion?: string;
}

export const initialState: TrustTaxInfoState = {
  ein: '',
  withholdingQuestion: YesNoEmpty.EMPTY,
  signature: '',
  date: '',
  ssn: '',
  grantorName: '',
};

const trustTaxReducer = createReducer(
  initialState,
  on(trustActions.TrustTaxUpdate, (_state, { payload }) => ({
    ...payload,
  })),
);

export function reducer(state: TrustTaxInfoState, action: Action) {
  return trustTaxReducer(state, action);
}
